import Repository from '@/repositories/base/Repository';
import SensediaConfiguration from '@/domain/models/integrator/SensediaConfiguration';
import FeatureFlagConfiguration from '@/domain/models/integrator/FeatureFlagConfiguration';
import DatabaseConnectionConfiguration from '@/domain/models/integrator/DatabaseConnectionConfiguration';
import IntegratorSensediaConfigRequest from '@/views/integratorConfig/interfaces/requests/IntegratorSensediaConfigRequest';
import IntegratorFeatureFlagConfigRequest from '@/views/integratorConfig/interfaces/requests/IntegratorFeatureFlagConfigRequest';
import IntegratorDatabaseConnectionConfigRequest from '@/views/integratorConfig/interfaces/requests/IntegratorDatabaseConnectionConfigRequest';
import InnCashCredentialsConfiguration from '@/domain/models/integrator/InnCashCredentialsConfiguration';
import IntegratorInnCashCredentialsConfigRequest from '@/views/integratorConfig/interfaces/requests/IntegratorInnCashCredentialsConfigRequest';
import CompanyAndBranchConfiguration from '@/domain/models/integrator/CompanyAndBranchConfiguration';
import IntegratorBranchAndCompanyConfigRequest from '@/views/integratorConfig/interfaces/requests/IntegratorBranchAndCompanyConfigRequest';
import RefreshAllManagementConfiguration from '@/domain/models/integrator/RefreshAllManagementConfiguration';
import IntegratorRefreshAllManagementConfigRequest from '@/views/integratorConfig/interfaces/requests/IntegratorRefreshAllManagementConfigRequest';
import TableConfigurations from '@/domain/models/integrator/TableConfigurations';
import IntegratorTablesWithFieldsConfigRequest from '@/views/integratorConfig/interfaces/requests/IntegratorTablesWithFieldsConfigRequest';
import IntegratorTableNameEnum from '@/views/integratorConfig/enums/IntegratorTableNameEnum';
import DefaultFieldsConfiguration from '@/domain/models/integrator/DefaultFieldsConfiguration';
import IntegratorBranchConfigurationsRequest from '@/views/integratorConfig/interfaces/requests/IntegratorBranchConfigurationsRequest';
import BranchConfiguration from '@/domain/models/integrator/BranchConfiguration';
import DatabaseConnectionsConfigurationList from '@/domain/models/integrator/DatabaseConnectionsConfigurationList';

export default class IntegratorDatabaseConnectionsRepository extends Repository {
  async getDatabaseConnectionConfigurationsList(
    companyGroupId: number,
  ): Promise<DatabaseConnectionsConfigurationList[]> {
    const { data: response } = await this.datasource.get(`company-groups/${companyGroupId}/integrator/database-connections`);

    return response.data.map(DatabaseConnectionsConfigurationList.make);
  }

  async getDatabaseConnectionConfigurationByAlias(
    companyGroupId: number,
    databaseAlias: string,
  ): Promise<DatabaseConnectionConfiguration> {
    const { data: response } = await this.datasource.get(`company-groups/${companyGroupId}/integrator/database-connections/${databaseAlias}`);

    return DatabaseConnectionConfiguration.make(response.data);
  }

  async upsertDatabaseConnectionConfiguration(
    companyGroupId: number,
    params: IntegratorDatabaseConnectionConfigRequest,
  ): Promise<void> {
    await this.datasource.send(`company-groups/${companyGroupId}/integrator/database-connections`, params);
  }

  async deleteDatabaseConnecitonConfiguration(
    companyGroupId: number,
    databaseAlias: string,
  ): Promise<void> {
    await this.datasource.destroy(`company-groups/${companyGroupId}/integrator/database-connections/${databaseAlias}`);
  }
}
